// A vendor slug or a record id in the path makes every visitor produce their own
// distinct "page", which turns a top-pages list into thousands of one-hit rows.
// Collapsing them is what keeps the numbers readable.
const NUMERIC = /^\d+$/;
const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Rewrites the variable segments of a pathname to placeholders:
 * `/dashboard/quotes/1042` -> `/dashboard/quotes/:id`.
 */
export const normalizePath = (pathname: string): string => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) return "/";

  const normalized = segments.map((segment) => {
    if (NUMERIC.test(segment)) return ":id";
    if (UUID.test(segment)) return ":id";
    return segment;
  });

  return `/${normalized.join("/")}`;
};
